<template>
	<Transition
		:enter-active-class="$style['cart-transition--entering']"
		:enter-class="$style['cart-transition--enter-start']"
		:enter-to-class="$style['cart-transition--enter-end']"
		:leave-active-class="$style['cart-transition--exiting']"
		:leave-to-class="$style['cart-transition--exit-end']"
		mode="out-in"
	>
		<CartWrapper
			v-if="showCart && !minified"
			id="cartWrapper"
			:cart="cart"
			:fetch-cart="fetchCart"
			:delete-cart="deleteCart"
			:update-cart="updateCart"
			:cart-products="cartProducts"
			:loading="cartLoading"
			@toggle="minified=true"
		/>
		<CartMini
			v-if="showCart && minified"
			:cart="cart"
			:cart-products="cartProducts"
			:loading="cartLoading"
			@toggle="minified=false"
		/>
	</Transition>
</template>

<script>
import CartWrapper from './CartWrapper'
import CartMini from './CartMini'

import { mapGetters } from '@/store/modules/App/Cart/helpers'
import {  mapActions } from '@/store/modules/App/Cart/helpers'
import {
	FETCH_CART,
	FETCH_CART_PRODUCTS,
	DELETE_CART,
	UPDATE_CART
} from '@/store/modules/App/Cart/action-types'

export default {
	name: 'Cart',
	components: {
		CartWrapper,
		CartMini
	},
	data () {
		return {
			minified: false,
			prevScrollValue: 0,
			scrollRafId: null
		}
	},



	computed: {

		...mapGetters({
			cart: 'cart',
			cartProducts: 'cartProducts',
			loading: 'loading'

		}),
		showCart () {
			return this.$auth().selectedCartId
		},

		cartLoading () {
			const loaders = ['createCart', 'cart', 'addToCart', 'updateCart']
			return loaders.some(loaderKey => this.loading[loaderKey])
		}



	},
	watch: {
		showCart: {
			immediate: true,
			handler () {
				if (this.showCart && this.$auth().selectedCartId !== this.cart?.id) {
					this.fetchCart(this.$auth().selectedCartId)
					this.fetchCartProducts({
						cartIds: [this.$auth().selectedCartId],
						productQueryType: 'cart'
					})
				}
			}
		}

	},

	mounted () {
		this.scrollContainer = document.getElementById('dashboard-main') || window
		this.scrollContainer.addEventListener('scroll', this._onScroll, { passive: true })
		this.handleCheckCartVisible()
	},

	beforeDestroy () {
		if (this.scrollContainer) {
			this.scrollContainer.removeEventListener('scroll', this._onScroll, { passive: true })
		}
		if (this.scrollRafId) cancelAnimationFrame(this.scrollRafId)
	},

	methods: {

		_onScroll () {
			if (this.scrollRafId) return
			this.scrollRafId = requestAnimationFrame(() => {
				this.scrollRafId = null
				this.handleCheckCartVisible()
			})
		},

		handleCheckCartVisible () {
			if (!this.minified && document.getElementById('cartWrapper')) {
				const scroller = this.scrollContainer || window
				const isWindow = scroller === window
				const documentHeight = isWindow ? document.body.scrollHeight : scroller.scrollHeight
				const currentScroll = isWindow
					? window.scrollY + window.innerHeight
					: scroller.scrollTop + scroller.clientHeight
				if (this.prevScrollValue > currentScroll) {
					return
				}
				this.prevScrollValue = currentScroll
				const modifier = 200
				if (currentScroll + modifier > documentHeight) {
					this.minified = true
				}
			}
		},

		...mapActions({
			fetchCart: FETCH_CART,
			fetchCartProducts: FETCH_CART_PRODUCTS,
			deleteCart: DELETE_CART,
			updateCart: UPDATE_CART
		})


	}
}
</script>

<style lang="scss" module>
.cart-transition {
		&--entering {
			transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1);
			transform-origin: center;
			will-change: transform;
		}

		&--enter-start {
			transform: translateY(100px);
		}

		&--enter-end {
			transform: translateY(0);
		}

		&--exiting {
			transition: opacity 0.1s linear,
			transform 0.12s cubic-bezier(0, 0, 0.2, 1);
			will-change: opacity, transform;
		}

		&--exit-start {
			transform: translateY(0);
		}

		&--exit-end {
			transform: translateY(100px);
			opacity: 0;
		}
	}
</style>
